
import compliance from '@/http/requests/compliance'
import vendor from '@/http/requests/vendor'

export default {
  fetchComplianceList ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.list(data)
        .then(response => {      
          if (data.page > 1) {
            commit('UPDATE_COMPLIANCE_LIST', response.data.data)
          } else {
            commit('SET_COMPLIANCE_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  update ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.update(data)
        .then(response => {
          commit('UPDATE_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateExpiration ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.updateExpiration(data)
        .then(response => {
          commit('UPDATE_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  delete ({ commit }, id) {
    return new Promise((resolve, reject) => {
     compliance.delete(id)
        .then(response => {
          commit('DELETE_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  add ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.store(data)
        .then(response => {
          commit('ADD_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  clearComplianceList({ commit }){
    commit('CLEAR_COMPLIANCE_LIST')
  },
  updateComplianceLease ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.updateComplianceLease(data)
        .then(response => {
          commit('UPDATE_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateComplianceLeaseInsurance ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.updateComplianceLeaseInsurance(data)
        .then(response => {
          commit('UPDATE_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //
  fetchVendorList ({ commit }, data = null) {
    return new Promise((resolve, reject) => {
      vendor.list(data)
        .then(response => {        
          commit('SET_VENDOR_LIST', response.data.vendors)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addVendor ({ commit }, data) {
    return new Promise((resolve, reject) => {
      vendor.store(data)
        .then(response => {
          commit('ADD_VENDOR',response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  validate ({ commit }, data) {
    return new Promise((resolve, reject) => {
      compliance.validate(data)
        .then(response => {
          commit('UPDATE_COMPLIANCE', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
